import addTimeToISOString from "./addTimeToISOString";

/**
 * Дополняет число до двух символов ведущим нулём.
 * @param {number|string} e - Число для дополнения.
 * @returns {string} Строка длиной минимум 2 символа.
 */
const setPadStart = (e) => e.toString().padStart(2, '0');

/**
 * Парсит ISO-строку даты и возвращает объект с компонентами даты и отформатированной строкой.
 * @param {string} str - ISO-строка даты.
 * @param {string} [utc] - Опциональный UTC offset для коррекции.
 * @returns {{name: string, year: string, month: string, day: string, hours: string, minutes: string, seconds: string, toFormat: string}|string} Объект с компонентами даты или пустая строка.
 */
function convertFormatDate(str, utc) {
  if (str) {
    const newStr = JSON.parse(JSON.stringify(str));
    let newDate = new Date(newStr);

    if (utc) {
      const zeroUtc = newStr.replace("Z", "");

      newDate = new Date(addTimeToISOString(zeroUtc, utc));
    }

    const newYear = newDate.getFullYear();
    const newMonth = newDate.getMonth();
    const newDay = newDate.getDate();
    const newHours = newDate.getHours();
    const newMinutes = newDate.getMinutes();
    const newSeconds = newDate.getSeconds();

    const name = setPadStart(newDate);
    const year = setPadStart(newYear);
    const month = setPadStart(newMonth + 1);
    const day = setPadStart(newDay);
    const hours = setPadStart(newHours);
    const minutes = setPadStart(newMinutes);
    const seconds = setPadStart(newSeconds);

    return {
      name,
      year,
      month,
      day,
      hours,
      minutes,
      seconds,
      toFormat: `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
    };
  }
  return '';
}

export default convertFormatDate;
